
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/client",
      function () {
        return require("private-next-pages/signup/client.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/client"])
      });
    }
  